// there's no cancellation fee
// there's no cost the reservation
// and the venue allows to bypass a payment method (1)
const getPaymentRequired = (reservationDetails) => reservationDetails?.cancellation?.fee !== null
  || reservationDetails?.payment?.amounts?.total !== 0
  || reservationDetails?.venue?.config?.allow_bypass_payment_method !== 1;

export default getPaymentRequired;
